import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import QRCode from 'react-qr-code';
import noImg from "../../../assets/food/foodofferimg.png";
import activeGif from "../../../assets/food/active.gif";
import { formatDateWithOrdinal } from './commonFunction';

export const FoodOfferCard = ({ id, link, image, title, validity, onError, removeLink, onRemove, voucherNo, data, cartPage, className }) => {
	const navigate = useNavigate();

	const prepareMultiOrderStatus = JSON.parse(localStorage.getItem("prepareMultiOrderStatus"));
	const theatreId = JSON.parse(localStorage.getItem("TheatreId"));
	const cartOffers = JSON.parse(localStorage.getItem("cartOffers") || "[]").filter(item => item?.theatreId === theatreId);

	const removeOfferCard = (e, id) => {
		e.preventDefault();
		e.stopPropagation();

		if (onRemove) {
			onRemove(id);
		}
	};
	// const formattedDate = new Date(validity).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });

	const handleImageError = (e) => {
		e.target.src = noImg;
	};

	const handleRedirection = (item) => {
		if (item.active) {

			const selectedTheater = JSON.parse(localStorage.getItem("selectedTheater")) || [];
			const activateParameter = [{
				activatedDate: item.purchaseDate,
				errorMsg: "",
				expiryDate: item.expDate,
				// purchaseDate: item.purchaseDate,
				voucherDesc: item.voucherDesc,
				voucherId: item.voucherId,
				voucherNo: item.voucherNo,
				voucherStatus: 0,
				// voucherRedeemed: item.voucherStatus,
				theatreId: parseInt(selectedTheater.theatreId),
				theatreName: selectedTheater.name
			}];


			localStorage.setItem("FoodListTimerId", JSON.stringify(activateParameter))
			navigate("/offeractivated");
		} else {
			localStorage.setItem("foodoffers", JSON.stringify(item));
			navigate(`/redeem-offers/${item.voucherDesc?.replace(/[^a-zA-Z0-9\s.]/g, '').replace(/[\s.]+/g, '-').toLowerCase()}`);
		}
	}

	return (
		<>
			{data?.length > 0 && data?.some(item => new Date(item.validTill).getTime() >= new Date().setHours(0, 0, 0, 0)) ? (
				data.map((item) => {
					const validTillDate = new Date(item.validTill).getTime();
					const today = new Date().setHours(0, 0, 0, 0);
					const formattedDate = formatDateWithOrdinal(item.validTill, false);
					const inCart = cartOffers?.some(cart => cart?.voucherId === item?.voucherId);
					// const activeVoucherNo = prepareMultiOrderStatus.flatMap(item => item.activateVoucher.filter(item => item.voucherNo === item?.voucherNo));
					const isActive = item?.active && item?.voucherStatus.toLowerCase() !== "redeemed"
					return (
						validTillDate >= today && (
							<div key={item.voucherNo} className={`foodCardinr ${className}`} onClick={() => handleRedirection(item)} >
								<div className="foodCardli">
									{isActive
										? <p className="tagvoucherNo shimmer">Active</p>
										: cartPage && inCart
											? <p className='tagvoucherNo inCart'>In Cart</p>
											: null
									}
									<img
										className="offerImg"
										src={item.voucherImageUrl || noImg}
										width="100%"
										alt={item.voucherDesc}
										onError={handleImageError}
									/>
									{/* <svg className="cartVg" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect x="0.5" y="0.5" width="13" height="13" rx="1.5" stroke="#149752" />
										<circle cx="6.99984" cy="6.99935" r="4.08333" fill="#149752" />
									</svg> */}
									<div className="foodDisc">
										<h4>{item.voucherDesc}</h4>
										<p>Valid till {formattedDate}</p>
										{removeLink && (
											<button className='removebtn' onClick={(e) => removeOfferCard(e, item.voucherId)}>{removeLink}</button>
										)}
									</div>
								</div>
							</div>
						)
					);
				})
			) : (
				<p className="no-found-fnbP">No Offers found!</p>
			)}
		</>
	)
}

// export const FoodVoucherCard = ({ link, qrcode, title, validity }) => {
// 	const formattedDate = new Date(validity).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
// 	return (
// 		<>
// 			{new Date(validity).getTime() >= new Date().setHours(0, 0, 0, 0) ? (
// 				<Link to={link} className="foodCardinr">
// 					<div className="foodCardli">
// 						<div className="qrcodevhr">
// 							<QRCode className='qrcodesvg'
// 								title="PVRINOX"
// 								value={qrcode ? qrcode : "INVALID_CODE"}
// 								bgColor="#FFFFFF"
// 								fgColor="#000000"
// 								size={60}
// 							/>
// 						</div>
// 						<div className="foodDisc">
// 							<h4>{title}</h4>
// 							<p>Valid till {formattedDate}</p>
// 						</div>
// 					</div>
// 				</Link>
// 			) : ""}
// 		</>
// 	)
// }

// export default FoodOfferCard
